const setPagination = ({ commit }, pagination) => {
    commit('SET_CURRENT_PAGINATION', pagination)
}

const setCurrentList = ({ commit }, list) => {
    commit('SET_CURRENT_LIST', list)
}

const resetState = function({ commit }, obj) {
    commit('SET_CURRENT_LIST', obj.data)
    commit('SET_CURRENT_MODEL', obj.model)
    commit('SET_CURRENT_PAGINATION', obj.pagination)
}

export default {
    resetState,
    setPagination,
    setCurrentList,
}
